import React, { useEffect, useState } from 'react';

import { Col, Form, Input, Layout, Row, message } from 'antd';

import { PageSpinner } from 'components/page-spinner';
import PdButton from 'components/pd-button';
import PdUploader from 'components/pd-uploader';

import AboutServices from 'services/about';

import { errHandling } from 'utils';
import { useNavigate } from 'react-router-dom';

const { Content } = Layout;

const FIELDS = {
  DESCRIPTION: 'description',
  DESCRIPTION_BAHASA: 'description_idn',
  IMAGE: 'image_url',
  TITLE: 'title',
};

export function CreateEditValue() {
  const [form] = Form.useForm();
  const [loadingButton, setLoadingButton] = useState(false);
  const [loadingPage, setLoadingPage] = useState(false);
  const [value, setValue] = useState({});
  const navigate = useNavigate();

  const urlParams = new URLSearchParams(location.search);
  const pageId = urlParams.get('id');

  async function handleSubmit(values) {
    try {
      const payload = { company_value: { ...values } };
      setLoadingButton(true);
      if (pageId) {
        await AboutServices.updateAbout(payload, pageId);
      } else {
        const {
          data: { data = [] },
        } = await AboutServices.getAbout(true);
        if (data.length <= 3) await AboutServices.createCompanyValue(payload);
        else message.error('Maximum company value is 4 items');
      }
      navigate('/about_us_pages/value');
    } catch (err) {
      errHandling(err);
    } finally {
      setLoadingButton(false);
    }
  }

  function handleUploadImage(imgUrl) {
    form.setFieldsValue({ [FIELDS.IMAGE]: imgUrl });
    setValue((prev) => ({ ...prev, [FIELDS.IMAGE]: imgUrl }));
  }

  async function fetchValue() {
    setLoadingPage(true);
    try {
      const {
        data: { data = {} },
      } = await AboutServices.getCompanyValueDetail(pageId);
      setValue(data);
    } catch (error) {
      errHandling(error);
    } finally {
      setLoadingPage(false);
    }
  }

  useEffect(() => {
    if (pageId) fetchValue();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (loadingPage) return <PageSpinner />;
  return (
    <Layout className="pd-cms-about-us main-container">
      <div className="container">
        <div className="content">
          <div className="pageTitle">{pageId ? 'Edit' : 'Add New'} Value</div>
          <Content className="pageContent">
            <Form
              layout="vertical"
              form={form}
              onFinish={handleSubmit}
              className="pd-value-form"
              initialValues={{
                [FIELDS.IMAGE]: value[FIELDS.IMAGE],
                [FIELDS.TITLE]: value[FIELDS.TITLE],
                [FIELDS.DESCRIPTION]: value[FIELDS.DESCRIPTION],
                [FIELDS.DESCRIPTION_BAHASA]: value[FIELDS.DESCRIPTION_BAHASA],
              }}>
              <Row>
                <Col lg={4}>
                  <Form.Item label="Icon Value" name={FIELDS.IMAGE}>
                    <PdUploader
                      alt="icon-value-img"
                      afterUpload={handleUploadImage}
                      imgUrl={value[FIELDS.IMAGE]}
                    />
                  </Form.Item>
                </Col>
                <Col lg={{ span: 19, offset: 1 }}>
                  <Row>
                    <Form.Item
                      className="w-full"
                      label="Title Value"
                      name={FIELDS.TITLE}
                      rules={[
                        {
                          required: true,
                          message: 'Enter the title',
                        },
                      ]}>
                      <Input placeholder="Write value title" />
                    </Form.Item>
                  </Row>
                  <Row>
                    <Form.Item
                      className="w-full"
                      label="Description"
                      name={FIELDS.DESCRIPTION}
                      rules={[
                        {
                          required: true,
                          message: 'Enter the description',
                        },
                      ]}>
                      <Input placeholder="Write value description" />
                    </Form.Item>
                  </Row>
                  <Row>
                    <Form.Item
                      className="w-full"
                      label="Description (Bahasa)"
                      name={FIELDS.DESCRIPTION_BAHASA}
                      rules={[
                        {
                          required: true,
                          message: 'Enter the description',
                        },
                      ]}>
                      <Input placeholder="Write value description" />
                    </Form.Item>
                  </Row>
                </Col>
              </Row>
              <Form.Item className="pd-margin-top-lg">
                <PdButton
                  className="height-32"
                  full
                  type="primary"
                  htmlType="submit"
                  loading={loadingButton}>
                  Publish
                </PdButton>
              </Form.Item>
            </Form>
          </Content>
        </div>
      </div>
    </Layout>
  );
}
